const aigConfig = Object.freeze({
    LABEL: 'AIG Medical Indemnity',
    SHORT_LABEL: 'AIG',
    NAME: 'aig',
    URL_BASE: 'https://joinansel.com',
    PALETTE: {
        PRIMARY: '#001871',
        SECONDARY: '#1352DE'
    },
    CONTACT_SUPPORT: {
        EMAIL: 'aigmedicalindemnitysupport@joinansel.com',
        NUMBER: '(888) 499-1088',
        WEB_SITE: 'https://www.joinansel.com'
    },
    S3: {
        BASE_URL: 'https://joinansel-platform-assets.s3.amazonaws.com',
        SP_NAME: 'aig',
        APPLICATION: 'enrollment',
    },
    LEGAL:{
        SERVICE_NAME: 'AIG, Inc.',
        INSURANCE_NAME: 'Ansel Health, Inc.',
        TERMS: 'https://www.joinansel.com/terms',
        PRIVACY: 'https://www.joinansel.com/privacy-policy'
    },
});

export default aigConfig;